import React from "react";

/**
 * Renders a document strictly in Times New Roman 12pt, justified.
 * Preserves paragraph structure from LLM output.
 */
function buildParagraphs(content) {
  // Clés stables basées sur le contenu (compteur d'occurrences pour les paragraphes identiques)
  if (!content) return [];
  const seen = new Map();
  return content.split(/\n\n+/).map((p) => p.trim()).filter(Boolean).map((trimmed) => {
    const base = `${trimmed.length}-${trimmed.slice(0, 40)}`;
    const occ = (seen.get(base) || 0) + 1;
    seen.set(base, occ);
    return { key: `${base}#${occ}`, text: trimmed };
  });
}

export default function DocumentPreview({ content, className = "" }) {
  const paras = buildParagraphs(content);
  if (!content) return null;
  return (
    <div className={`doc-preview p-8 bg-white border border-zinc-200 rounded-md ${className}`}>
      {paras.map(({ key, text }) => {
        const isHeading = /^([0-9]+\.\s+)?[A-ZÀ-ÖØ-Þ0-9 ,\-'’()/]+$/u.test(text) && text.length < 120;
        if (isHeading) {
          return <h3 key={key} className="mt-4 mb-2 font-bold uppercase text-[12pt]">{text}</h3>;
        }
        return <p key={key} className="mb-3">{text}</p>;
      })}
    </div>
  );
}

export function downloadDocx(title, content) {
  // Minimal RTF-like .doc export (Word-compatible). Times New Roman 12, justified.
  const paras = content.split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
  const body = paras.map((p) => {
    const isHeading = /^([0-9]+\.\s+)?[A-ZÀ-ÖØ-Þ0-9 ,\-'’()/]+$/u.test(p) && p.length < 120;
    const esc = p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    if (isHeading) return `<p style="font-family:'Times New Roman',serif;font-size:12pt;font-weight:bold;text-align:left;margin:10pt 0 4pt;">${esc}</p>`;
    return `<p style="font-family:'Times New Roman',serif;font-size:12pt;text-align:justify;margin:0 0 8pt;">${esc}</p>`;
  }).join("");
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title></head><body>${body}</body></html>`;
  const blob = new Blob(["\ufeff", html], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `${title.replace(/[^\w\-]+/g, "_")}.doc`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
